import { FC, useState } from 'react';
// import { Table, Typography } from 'antd';
import { useQuery } from '@tanstack/react-query';
import DataRow from '@/libs/antd/components/DataRow';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { getManagementDetail } from '@/libs/fleet-api/services/customer';
import { useModals } from './ModalProvider';
import { FleetFile } from '@/libs/fleet-api/fetcher';
import { CustomerManagement } from '@/libs/fleet-api/services/types';

export type ManagementModalState = null | number | CustomerManagement;

export type ManagementModalProps = {
	modal: ManagementModalState;
	onClose: () => void;
};

const ManagementModal: FC<ManagementModalProps> = ({ modal, onClose }) => {
	const { data, isLoading } = useQuery({
		queryKey: ['getManagementDetail', modal] as const,
		queryFn: ({ queryKey }) => {
			const [, id] = queryKey;
			if (!id || typeof id !== 'number') return null;
			return getManagementDetail(id);
		},
		enabled: typeof modal === 'number',
	});

	const { openPreviewModal } = useModals();

	const {
		name,
		identityNumber,
		dateOfBirth,
		address,
		rt,
		rw,
		phoneNumber,
		isShareholder,
		shareholding,
		citizenship,
		nationality,
		identityCardType,
		position,
		postal,
		identityFile,
		status,
		// address,
		// creditLimit,
		// isActive
	} = data?.data ?? (modal as CustomerManagement) ?? {};

	return (
		<FleetModal
			open={Boolean(modal)}
			width={940}
			cancelText="BACK"
			buttonPosition="end"
			closable={false}
			okButtonProps={{
				hidden: true,
			}}
			onCancel={() => onClose?.()}
		>
			<FleetTitle>Detil Pengurus</FleetTitle>
			<DataRow
				loading={isLoading}
				items={[
					[
						['Nama Pengurus', name],
						['Kewarganegaraan', citizenship?.value],
					],
					[
						['Nationality', nationality?.value],
						['Jenis Identitas', identityCardType?.value],
					],
					[
						['No. ID', identityNumber],
						[
							'Identitas File',
							identityFile ? (
								<a
									href="#"
									onClick={(e) => {
										e.preventDefault();
										openPreviewModal(identityFile as FleetFile);
									}}
								>
									Lihat File
								</a>
							) : (
								'-'
							),
						],
					],
					[
						['Tanggal Lahir', dateOfBirth],
						['Jabatan', position?.value],
					],
					[
						['Alamat', address],
						['RT/RW', `${rt}/${rw}`],
					],
					[
						['Kode Pos', postal?.postalCode],
						['Kelurahan', postal?.locationName],
					],
					[
						['Kecamatan', postal?.districtName],
						['Kota', postal?.cityName],
					],
					[
						['No. Telepon', phoneNumber],
						['Status', status?.value],
					],
					[
						['Merupakan Pemegang Saham?', isShareholder ? 'Ya' : 'Tidak'],
						['Kepemilikan Saham', isShareholder ? `${shareholding}%` : '-'],
					],
				]}
				style={{
					marginBottom: 20,
				}}
			/>
		</FleetModal>
	);
};

export default ManagementModal;

export const useManagementModal = () => {
	return useState<ManagementModalState>(null);
};
